import React from 'react';
import { Box, Typography } from '@mui/material';

const MapFooter = () => {
  return (
    <div style={{ marginTop: '50px' }}>
      <Typography
        variant="h5"
        sx={{
          color: '#92b21f',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          mb: 2,
          textShadow: '0 0 8px rgba(146, 178, 31, 0.6)',
        }}
      >
        Onde estamos
      </Typography>
      <Box
        sx={{
          width: '100%', // garante largura total do container
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%', // ocupa toda a largura disponível
            maxWidth: '1200px', // limite opcional para layout
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 0 12px rgba(146, 178, 31, 0.3)',
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.0036329638074!2d-51.02576481329198!3d-26.77615412749481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94e6b738ed77c5e7%3A0xb10404f5b3d0be56!2sLoja%20Hi%20Cell!5e0!3m2!1spt-BR!2sbr!4v1749438273712!5m2!1spt-BR!2sbr"
            width="100%"
            height="350"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa da Loja Hi Cell"
          ></iframe>
        </Box>
      </Box>
    </div>
  );
};

export default MapFooter;
